module.exports = __webpack_public_path__ + "img/ford+usa.3f79bc88.png";